/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiPageSideBar = ({
  children,
  className,
  ...rest
}) => {
  const classes = classNames('euiPageSideBar', className);
  return <div className={classes} {...rest}>
      {children}
    </div>;
};
EuiPageSideBar.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};

try {
  // @ts-ignore
  EuiPageSideBar.displayName = "EuiPageSideBar"; // @ts-ignore

  EuiPageSideBar.__docgenInfo = {
    "description": "",
    "displayName": "EuiPageSideBar",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-label": {
        "defaultValue": null,
        "description": "",
        "name": "aria-label",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "data-test-subj": {
        "defaultValue": null,
        "description": "",
        "name": "data-test-subj",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "defaultChecked": {
        "defaultValue": null,
        "description": "",
        "name": "defaultChecked",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "defaultValue": {
        "defaultValue": null,
        "description": "",
        "name": "defaultValue",
        "required": false,
        "type": {
          "name": "string | number | string[] | undefined"
        }
      },
      "suppressContentEditableWarning": {
        "defaultValue": null,
        "description": "",
        "name": "suppressContentEditableWarning",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "suppressHydrationWarning": {
        "defaultValue": null,
        "description": "",
        "name": "suppressHydrationWarning",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "accessKey": {
        "defaultValue": null,
        "description": "",
        "name": "accessKey",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "contentEditable": {
        "defaultValue": null,
        "description": "",
        "name": "contentEditable",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"inherit\" | undefined"
        }
      },
      "contextMenu": {
        "defaultValue": null,
        "description": "",
        "name": "contextMenu",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "dir": {
        "defaultValue": null,
        "description": "",
        "name": "dir",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "draggable": {
        "defaultValue": null,
        "description": "",
        "name": "draggable",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "hidden": {
        "defaultValue": null,
        "description": "",
        "name": "hidden",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "id": {
        "defaultValue": null,
        "description": "",
        "name": "id",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "lang": {
        "defaultValue": null,
        "description": "",
        "name": "lang",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "placeholder": {
        "defaultValue": null,
        "description": "",
        "name": "placeholder",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "slot": {
        "defaultValue": null,
        "description": "",
        "name": "slot",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "spellCheck": {
        "defaultValue": null,
        "description": "",
        "name": "spellCheck",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "style": {
        "defaultValue": null,
        "description": "",
        "name": "style",
        "required": false,
        "type": {
          "name": "CSSProperties | undefined"
        }
      },
      "tabIndex": {
        "defaultValue": null,
        "description": "",
        "name": "tabIndex",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "title": {
        "defaultValue": null,
        "description": "",
        "name": "title",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "translate": {
        "defaultValue": null,
        "description": "",
        "name": "translate",
        "required": false,
        "type": {
          "name": "\"yes\" | \"no\" | undefined"
        }
      },
      "radioGroup": {
        "defaultValue": null,
        "description": "",
        "name": "radioGroup",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "role": {
        "defaultValue": null,
        "description": "",
        "name": "role",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "about": {
        "defaultValue": null,
        "description": "",
        "name": "about",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "datatype": {
        "defaultValue": null,
        "description": "",
        "name": "datatype",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "inlist": {
        "defaultValue": null,
        "description": "",
        "name": "inlist",
        "required": false,
        "type": {
          "name": "any"
        }
      },
      "prefix": {
        "defaultValue": null,
        "description": "",
        "name": "prefix",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "property": {
        "defaultValue": null,
        "description": "",
        "name": "property",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "resource": {
        "defaultValue": null,
        "description": "",
        "name": "resource",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "typeof": {
        "defaultValue": null,
        "description": "",
        "name": "typeof",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "vocab": {
        "defaultValue": null,
        "description": "",
        "name": "vocab",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "autoCapitalize": {
        "defaultValue": null,
        "description": "",
        "name": "autoCapitalize",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "autoCorrect": {
        "defaultValue": null,
        "description": "",
        "name": "autoCorrect",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "autoSave": {
        "defaultValue": null,
        "description": "",
        "name": "autoSave",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "color": {
        "defaultValue": null,
        "description": "",
        "name": "color",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "itemProp": {
        "defaultValue": null,
        "description": "",
        "name": "itemProp",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "itemScope": {
        "defaultValue": null,
        "description": "",
        "name": "itemScope",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "itemType": {
        "defaultValue": null,
        "description": "",
        "name": "itemType",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "itemID": {
        "defaultValue": null,
        "description": "",
        "name": "itemID",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "itemRef": {
        "defaultValue": null,
        "description": "",
        "name": "itemRef",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "results": {
        "defaultValue": null,
        "description": "",
        "name": "results",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "security": {
        "defaultValue": null,
        "description": "",
        "name": "security",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "unselectable": {
        "defaultValue": null,
        "description": "",
        "name": "unselectable",
        "required": false,
        "type": {
          "name": "\"on\" | \"off\" | undefined"
        }
      },
      "inputMode": {
        "defaultValue": null,
        "description": "Hints at the type of data that might be entered by the user while editing the element or its contents\n@see https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute",
        "name": "inputMode",
        "required": false,
        "type": {
          "name": "\"none\" | \"text\" | \"tel\" | \"url\" | \"email\" | \"numeric\" | \"decimal\" | \"search\" | undefined"
        }
      },
      "is": {
        "defaultValue": null,
        "description": "Specify that a standard HTML element should behave like a defined custom built-in element\n@see https://html.spec.whatwg.org/multipage/custom-elements.html#attr-is",
        "name": "is",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-activedescendant": {
        "defaultValue": null,
        "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
        "name": "aria-activedescendant",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-atomic": {
        "defaultValue": null,
        "description": "Indicates whether assistive technologies will present all, or only parts of, the changed region based on the change notifications defined by the aria-relevant attribute.",
        "name": "aria-atomic",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-autocomplete": {
        "defaultValue": null,
        "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
        "name": "aria-autocomplete",
        "required": false,
        "type": {
          "name": "\"none\" | \"inline\" | \"list\" | \"both\" | undefined"
        }
      },
      "aria-busy": {
        "defaultValue": null,
        "description": "Indicates an element is being modified and that assistive technologies MAY want to wait until the modifications are complete before exposing them to the user.",
        "name": "aria-busy",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-checked": {
        "defaultValue": null,
        "description": "Indicates the current \"checked\" state of checkboxes, radio buttons, and other widgets.\n@see aria-pressed\n@see aria-selected.",
        "name": "aria-checked",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"mixed\" | undefined"
        }
      },
      "aria-colcount": {
        "defaultValue": null,
        "description": "Defines the total number of columns in a table, grid, or treegrid.\n@see aria-colindex.",
        "name": "aria-colcount",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-colindex": {
        "defaultValue": null,
        "description": "Defines an element's column index or position with respect to the total number of columns within a table, grid, or treegrid.\n@see aria-colcount\n@see aria-colspan.",
        "name": "aria-colindex",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-colspan": {
        "defaultValue": null,
        "description": "Defines the number of columns spanned by a cell or gridcell within a table, grid, or treegrid.\n@see aria-colindex\n@see aria-rowspan.",
        "name": "aria-colspan",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-controls": {
        "defaultValue": null,
        "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.\n@see aria-owns.",
        "name": "aria-controls",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-current": {
        "defaultValue": null,
        "description": "Indicates the element that represents the current item within a container or set of related elements.",
        "name": "aria-current",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"page\" | \"step\" | \"location\" | \"date\" | \"time\" | undefined"
        }
      },
      "aria-describedby": {
        "defaultValue": null,
        "description": "Identifies the element (or elements) that describes the object.\n@see aria-labelledby",
        "name": "aria-describedby",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-details": {
        "defaultValue": null,
        "description": "Identifies the element that provides a detailed, extended description for the object.\n@see aria-describedby.",
        "name": "aria-details",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-disabled": {
        "defaultValue": null,
        "description": "Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.\n@see aria-hidden\n@see aria-readonly.",
        "name": "aria-disabled",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-dropeffect": {
        "defaultValue": null,
        "description": "Indicates what functions can be performed when a dragged object is released on the drop target.\n@deprecated in ARIA 1.1",
        "name": "aria-dropeffect",
        "required": false,
        "type": {
          "name": "\"none\" | \"copy\" | \"execute\" | \"link\" | \"move\" | \"popup\" | undefined"
        }
      },
      "aria-errormessage": {
        "defaultValue": null,
        "description": "Identifies the element that provides an error message for the object.\n@see aria-invalid\n@see aria-describedby.",
        "name": "aria-errormessage",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-expanded": {
        "defaultValue": null,
        "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
        "name": "aria-expanded",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-flowto": {
        "defaultValue": null,
        "description": "Identifies the next element (or elements) in an alternate reading order of content which, at the user's discretion,\nallows assistive technology to override the general default of reading in document source order.",
        "name": "aria-flowto",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-grabbed": {
        "defaultValue": null,
        "description": "Indicates an element's \"grabbed\" state in a drag-and-drop operation.\n@deprecated in ARIA 1.1",
        "name": "aria-grabbed",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-haspopup": {
        "defaultValue": null,
        "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
        "name": "aria-haspopup",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"menu\" | \"listbox\" | \"tree\" | \"grid\" | \"dialog\" | undefined"
        }
      },
      "aria-hidden": {
        "defaultValue": null,
        "description": "Indicates whether the element is exposed to an accessibility API.\n@see aria-disabled.",
        "name": "aria-hidden",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-invalid": {
        "defaultValue": null,
        "description": "Indicates the entered value does not conform to the format expected by the application.\n@see aria-errormessage.",
        "name": "aria-invalid",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"grammar\" | \"spelling\" | undefined"
        }
      },
      "aria-keyshortcuts": {
        "defaultValue": null,
        "description": "Indicates keyboard shortcuts that an author has implemented to activate or give focus to an element.",
        "name": "aria-keyshortcuts",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-labelledby": {
        "defaultValue": null,
        "description": "Identifies the element (or elements) that labels the current element.\n@see aria-describedby.",
        "name": "aria-labelledby",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-level": {
        "defaultValue": null,
        "description": "Defines the hierarchical level of an element within a structure.",
        "name": "aria-level",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-live": {
        "defaultValue": null,
        "description": "Indicates that an element will be updated, and describes the types of updates the user agents, assistive technologies, and user can expect from the live region.",
        "name": "aria-live",
        "required": false,
        "type": {
          "name": "\"off\" | \"assertive\" | \"polite\" | undefined"
        }
      },
      "aria-modal": {
        "defaultValue": null,
        "description": "Indicates whether an element is modal when displayed.",
        "name": "aria-modal",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-multiline": {
        "defaultValue": null,
        "description": "Indicates whether a text box accepts multiple lines of input or only a single line.",
        "name": "aria-multiline",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-multiselectable": {
        "defaultValue": null,
        "description": "Indicates that the user may select more than one item from the current selectable descendants.",
        "name": "aria-multiselectable",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-orientation": {
        "defaultValue": null,
        "description": "Indicates whether the element's orientation is horizontal, vertical, or unknown/ambiguous.",
        "name": "aria-orientation",
        "required": false,
        "type": {
          "name": "\"horizontal\" | \"vertical\" | undefined"
        }
      },
      "aria-owns": {
        "defaultValue": null,
        "description": "Identifies an element (or elements) in order to define a visual, functional, or contextual parent/child relationship\nbetween DOM elements where the DOM hierarchy cannot be used to represent the relationship.\n@see aria-controls.",
        "name": "aria-owns",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-placeholder": {
        "defaultValue": null,
        "description": "Defines a short hint (a word or short phrase) intended to aid the user with data entry when the control has no value.\nA hint could be a sample value or a brief description of the expected format.",
        "name": "aria-placeholder",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-posinset": {
        "defaultValue": null,
        "description": "Defines an element's number or position in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.\n@see aria-setsize.",
        "name": "aria-posinset",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-pressed": {
        "defaultValue": null,
        "description": "Indicates the current \"pressed\" state of toggle buttons.\n@see aria-checked\n@see aria-selected.",
        "name": "aria-pressed",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | \"mixed\" | undefined"
        }
      },
      "aria-readonly": {
        "defaultValue": null,
        "description": "Indicates that the element is not editable, but is otherwise operable.\n@see aria-disabled.",
        "name": "aria-readonly",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-relevant": {
        "defaultValue": null,
        "description": "Indicates what notifications the user agent will trigger when the accessibility tree within a live region is modified.\n@see aria-atomic.",
        "name": "aria-relevant",
        "required": false,
        "type": {
          "name": "\"text\" | \"additions\" | \"additions text\" | \"all\" | \"removals\" | undefined"
        }
      },
      "aria-required": {
        "defaultValue": null,
        "description": "Indicates that user input is required on the element before a form may be submitted.",
        "name": "aria-required",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-roledescription": {
        "defaultValue": null,
        "description": "Defines a human-readable, author-localized description for the role of an element.",
        "name": "aria-roledescription",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-rowcount": {
        "defaultValue": null,
        "description": "Defines the total number of rows in a table, grid, or treegrid.\n@see aria-rowindex.",
        "name": "aria-rowcount",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-rowindex": {
        "defaultValue": null,
        "description": "Defines an element's row index or position with respect to the total number of rows within a table, grid, or treegrid.\n@see aria-rowcount\n@see aria-rowspan.",
        "name": "aria-rowindex",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-rowspan": {
        "defaultValue": null,
        "description": "Defines the number of rows spanned by a cell or gridcell within a table, grid, or treegrid.\n@see aria-rowindex\n@see aria-colspan.",
        "name": "aria-rowspan",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-selected": {
        "defaultValue": null,
        "description": "Indicates the current \"selected\" state of various widgets.\n@see aria-checked\n@see aria-pressed.",
        "name": "aria-selected",
        "required": false,
        "type": {
          "name": "boolean | \"true\" | \"false\" | undefined"
        }
      },
      "aria-setsize": {
        "defaultValue": null,
        "description": "Defines the number of items in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.\n@see aria-posinset.",
        "name": "aria-setsize",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-sort": {
        "defaultValue": null,
        "description": "Indicates if items in a table or grid are sorted in ascending or descending order.",
        "name": "aria-sort",
        "required": false,
        "type": {
          "name": "\"none\" | \"ascending\" | \"descending\" | \"other\" | undefined"
        }
      },
      "aria-valuemax": {
        "defaultValue": null,
        "description": "Defines the maximum allowed value for a range widget.",
        "name": "aria-valuemax",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-valuemin": {
        "defaultValue": null,
        "description": "Defines the minimum allowed value for a range widget.",
        "name": "aria-valuemin",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-valuenow": {
        "defaultValue": null,
        "description": "Defines the current value for a range widget.\n@see aria-valuetext.",
        "name": "aria-valuenow",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "aria-valuetext": {
        "defaultValue": null,
        "description": "Defines the human readable text alternative of aria-valuenow for a range widget.",
        "name": "aria-valuetext",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "dangerouslySetInnerHTML": {
        "defaultValue": null,
        "description": "",
        "name": "dangerouslySetInnerHTML",
        "required": false,
        "type": {
          "name": "{ __html: string; } | undefined"
        }
      },
      "onCopy": {
        "defaultValue": null,
        "description": "",
        "name": "onCopy",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCopyCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCopyCapture",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCut": {
        "defaultValue": null,
        "description": "",
        "name": "onCut",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCutCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCutCapture",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPaste": {
        "defaultValue": null,
        "description": "",
        "name": "onPaste",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPasteCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPasteCapture",
        "required": false,
        "type": {
          "name": "((event: ClipboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionEnd",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionEndCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionEndCapture",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionStart": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionStart",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionStartCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionStartCapture",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionUpdate": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionUpdate",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onCompositionUpdateCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCompositionUpdateCapture",
        "required": false,
        "type": {
          "name": "((event: CompositionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onFocus": {
        "defaultValue": null,
        "description": "",
        "name": "onFocus",
        "required": false,
        "type": {
          "name": "((event: FocusEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onFocusCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onFocusCapture",
        "required": false,
        "type": {
          "name": "((event: FocusEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onBlur": {
        "defaultValue": null,
        "description": "",
        "name": "onBlur",
        "required": false,
        "type": {
          "name": "((event: FocusEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onBlurCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onBlurCapture",
        "required": false,
        "type": {
          "name": "((event: FocusEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onChange": {
        "defaultValue": null,
        "description": "",
        "name": "onChange",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onChangeCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onChangeCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onBeforeInput": {
        "defaultValue": null,
        "description": "",
        "name": "onBeforeInput",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onBeforeInputCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onBeforeInputCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onInput": {
        "defaultValue": null,
        "description": "",
        "name": "onInput",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onInputCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onInputCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onReset": {
        "defaultValue": null,
        "description": "",
        "name": "onReset",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onResetCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onResetCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onSubmit": {
        "defaultValue": null,
        "description": "",
        "name": "onSubmit",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onSubmitCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onSubmitCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onInvalid": {
        "defaultValue": null,
        "description": "",
        "name": "onInvalid",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onInvalidCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onInvalidCapture",
        "required": false,
        "type": {
          "name": "((event: FormEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onLoad": {
        "defaultValue": null,
        "description": "",
        "name": "onLoad",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onError": {
        "defaultValue": null,
        "description": "",
        "name": "onError",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onErrorCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onErrorCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onKeyDown": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyDown",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onKeyDownCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyDownCapture",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onKeyPress": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyPress",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onKeyPressCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyPressCapture",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onKeyUp": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyUp",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onKeyUpCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onKeyUpCapture",
        "required": false,
        "type": {
          "name": "((event: KeyboardEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAbort": {
        "defaultValue": null,
        "description": "",
        "name": "onAbort",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onAbortCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onAbortCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onCanPlay": {
        "defaultValue": null,
        "description": "",
        "name": "onCanPlay",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onCanPlayCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCanPlayCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onCanPlayThrough": {
        "defaultValue": null,
        "description": "",
        "name": "onCanPlayThrough",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onCanPlayThroughCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onCanPlayThroughCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onDurationChange": {
        "defaultValue": null,
        "description": "",
        "name": "onDurationChange",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onDurationChangeCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDurationChangeCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEmptied": {
        "defaultValue": null,
        "description": "",
        "name": "onEmptied",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEmptiedCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onEmptiedCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEncrypted": {
        "defaultValue": null,
        "description": "",
        "name": "onEncrypted",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEncryptedCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onEncryptedCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEnded": {
        "defaultValue": null,
        "description": "",
        "name": "onEnded",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onEndedCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onEndedCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadedData": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadedData",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadedDataCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadedDataCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadedMetadata": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadedMetadata",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadedMetadataCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadedMetadataCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadStart": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadStart",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onLoadStartCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLoadStartCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPause": {
        "defaultValue": null,
        "description": "",
        "name": "onPause",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPauseCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPauseCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPlay": {
        "defaultValue": null,
        "description": "",
        "name": "onPlay",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPlayCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPlayCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPlaying": {
        "defaultValue": null,
        "description": "",
        "name": "onPlaying",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onPlayingCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPlayingCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onProgress": {
        "defaultValue": null,
        "description": "",
        "name": "onProgress",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onProgressCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onProgressCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onRateChange": {
        "defaultValue": null,
        "description": "",
        "name": "onRateChange",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onRateChangeCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onRateChangeCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSeeked": {
        "defaultValue": null,
        "description": "",
        "name": "onSeeked",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSeekedCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onSeekedCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSeeking": {
        "defaultValue": null,
        "description": "",
        "name": "onSeeking",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSeekingCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onSeekingCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onStalled": {
        "defaultValue": null,
        "description": "",
        "name": "onStalled",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onStalledCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onStalledCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSuspend": {
        "defaultValue": null,
        "description": "",
        "name": "onSuspend",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSuspendCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onSuspendCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onTimeUpdate": {
        "defaultValue": null,
        "description": "",
        "name": "onTimeUpdate",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onTimeUpdateCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTimeUpdateCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onVolumeChange": {
        "defaultValue": null,
        "description": "",
        "name": "onVolumeChange",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onVolumeChangeCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onVolumeChangeCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onWaiting": {
        "defaultValue": null,
        "description": "",
        "name": "onWaiting",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onWaitingCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onWaitingCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onAuxClick": {
        "defaultValue": null,
        "description": "",
        "name": "onAuxClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onAuxClickCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onAuxClickCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onClick": {
        "defaultValue": null,
        "description": "",
        "name": "onClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onClickCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onClickCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onContextMenu": {
        "defaultValue": null,
        "description": "",
        "name": "onContextMenu",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onContextMenuCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onContextMenuCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onDoubleClick": {
        "defaultValue": null,
        "description": "",
        "name": "onDoubleClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onDoubleClickCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDoubleClickCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onDrag": {
        "defaultValue": null,
        "description": "",
        "name": "onDrag",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onDragEnd",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragEndCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragEndCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragEnter": {
        "defaultValue": null,
        "description": "",
        "name": "onDragEnter",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragEnterCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragEnterCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragExit": {
        "defaultValue": null,
        "description": "",
        "name": "onDragExit",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragExitCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragExitCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragLeave": {
        "defaultValue": null,
        "description": "",
        "name": "onDragLeave",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragLeaveCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragLeaveCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragOver": {
        "defaultValue": null,
        "description": "",
        "name": "onDragOver",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragOverCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragOverCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragStart": {
        "defaultValue": null,
        "description": "",
        "name": "onDragStart",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDragStartCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDragStartCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDrop": {
        "defaultValue": null,
        "description": "",
        "name": "onDrop",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onDropCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onDropCapture",
        "required": false,
        "type": {
          "name": "((event: DragEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onMouseDown": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseDown",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseDownCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseDownCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseEnter": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseEnter",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseLeave": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseLeave",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseMove": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseMove",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseMoveCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseMoveCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseOut": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseOut",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseOutCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseOutCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseOver": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseOver",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseOverCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseOverCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseUp": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseUp",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onMouseUpCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseUpCapture",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined"
        }
      },
      "onSelect": {
        "defaultValue": null,
        "description": "",
        "name": "onSelect",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onSelectCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onSelectCapture",
        "required": false,
        "type": {
          "name": "((event: SyntheticEvent<HTMLDivElement, Event>) => void) | undefined"
        }
      },
      "onTouchCancel": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchCancel",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchCancelCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchCancelCapture",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchEnd",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchEndCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchEndCapture",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchMove": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchMove",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchMoveCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchMoveCapture",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchStart": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchStart",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTouchStartCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTouchStartCapture",
        "required": false,
        "type": {
          "name": "((event: TouchEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerDown": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerDown",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerDownCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerDownCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerMove": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerMove",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerMoveCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerMoveCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerUp": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerUp",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerUpCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerUpCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerCancel": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerCancel",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerCancelCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerCancelCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerEnter": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerEnter",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerEnterCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerEnterCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerLeave": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerLeave",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerLeaveCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerLeaveCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerOver": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerOver",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerOverCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerOverCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerOut": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerOut",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onPointerOutCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onPointerOutCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onGotPointerCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onGotPointerCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onGotPointerCaptureCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onGotPointerCaptureCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onLostPointerCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLostPointerCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onLostPointerCaptureCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onLostPointerCaptureCapture",
        "required": false,
        "type": {
          "name": "((event: PointerEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onScroll": {
        "defaultValue": null,
        "description": "",
        "name": "onScroll",
        "required": false,
        "type": {
          "name": "((event: UIEvent<HTMLDivElement, UIEvent>) => void) | undefined"
        }
      },
      "onScrollCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollCapture",
        "required": false,
        "type": {
          "name": "((event: UIEvent<HTMLDivElement, UIEvent>) => void) | undefined"
        }
      },
      "onWheel": {
        "defaultValue": null,
        "description": "",
        "name": "onWheel",
        "required": false,
        "type": {
          "name": "((event: WheelEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onWheelCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onWheelCapture",
        "required": false,
        "type": {
          "name": "((event: WheelEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationStart": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationStart",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationStartCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationStartCapture",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationEnd",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationEndCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationEndCapture",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationIteration": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationIteration",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onAnimationIterationCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onAnimationIterationCapture",
        "required": false,
        "type": {
          "name": "((event: AnimationEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTransitionEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onTransitionEnd",
        "required": false,
        "type": {
          "name": "((event: TransitionEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onTransitionEndCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onTransitionEndCapture",
        "required": false,
        "type": {
          "name": "((event: TransitionEvent<HTMLDivElement>) => void) | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/page/page_side_bar/page_side_bar.tsx#EuiPageSideBar"] = {
      docgenInfo: EuiPageSideBar.__docgenInfo,
      name: "EuiPageSideBar",
      path: "src/components/page/page_side_bar/page_side_bar.tsx#EuiPageSideBar"
    };
} catch (__react_docgen_typescript_loader_error) {}